<template>
  <li class="offices-list__list-item col-12 col-md-6 col-lg-4">
    <div class="offices-list__list-item-container">
      <h3 class="offices-list__list-item-title">{{ item.title }}</h3>
      <p class="offices-list__list-item-country">{{ item.country_name }}</p>
      <a
        :href="`tel:${item.phone_tel_href}`"
        :title="`Call Tribal DDB in ${item.country_name}`"
        class="offices-list__list-item-link offices-list__list-item-link--phone"
        >{{ item.phone_display }}</a
      >
      <a
        :href="`mailto:${item.email}`"
        class="offices-list__list-item-link offices-list__list-item-link--email"
        >{{ item.email }}</a
      >
      <a
        :href="item.map_url"
        class="offices-list__list-item-link offices-list__list-item-link--map"
        >{{ item.map_display }}</a
      >
      <a
        :href="item.website_url"
        class="offices-list__list-item-link offices-list__list-item-link--website icon icon--arrow"
        ><span>{{ item.website_display }}</span></a
      >
    </div>
  </li>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.has-touch {
  .offices-list__list-item {
    .offices-list__list-item-link {
      color: $gray-500;
      opacity: 1;
      transform: translateY(0);
    }
  }
}
.offices-list__list-item {
  display: flex;
  padding: 0;
  margin: 0;

  &-container {
    display: flex;
    flex-direction: column;
    background-color: $tribal-white;
    border: 1px solid $gray-400;
    padding: spacer(3) spacer(2.5) spacer(2.5);
    margin: 0 spacer(1) spacer(1) 0;
    overflow: hidden;
    transition: background-color 0.2s;
    width: 100%;
  }

  .offices-list__list-item-link {
    @include font-size(16, rem-v(24));

    color: $black;
    display: block;
    padding: 0 0 spacer(0.3) 0;

    &--website {
      color: $yellow;
      padding-top: spacer(1);
      padding-bottom: 0;
      margin-left: 0;
      opacity: 0;
      transform: translateY(-20px);
      transition: all 0.3s ease-in;

      span {
        padding-left: spacer(0.5);
      }
    }

    &--email {
      word-break: break-word;
    }
  }

  &-title {
    @include font-size(36, rem-v(46));
    @include font-family($font-family-headings-bold, $headings-font-weight);

    flex: 1 1 auto;
    color: $black;
    margin: 0;
    padding: 0;
  }

  &-country {
    @include font-size(16, rem-v(24));
    @include font-family($font-family-headings-bold, $headings-font-weight);

    color: $black;
    padding: 0 0 spacer(1);
  }

  &:hover {
    .offices-list__list-item-container {
      background-color: $black;
      border-color: $gray-800;
      color: $white;
      box-shadow: 5px 5px 10px $gray-500;
    }

    .offices-list__list-item-country {
      color: $yellow;
    }

    .offices-list__list-item-title {
      color: $white;
    }

    .offices-list__list-item-link {
      color: $white;

      &:hover {
        color: $yellow;
        text-decoration: underline;

        &.offices-list__list-item-link--phone {
          text-decoration: none;
        }
      }

      &.offices-list__list-item-link--website {
        opacity: 1;
        transform: translateY(0);
        text-decoration: none;
        transition-timing-function: ease-out;

        span {
          text-decoration: none;

          &:hover {
            text-decoration: none;
          }
        }
      }
    }
  }
}

@include media-breakpoint-up(md) {
  .offices-list__list-item {
    &-title {
      min-height: 68px;
    }
  }
}
</style>
